import { MutationTree } from 'vuex';
import { IState, ITag } from './state';
import { ActionPayload } from './actions';
import { IItem } from './state';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
	state.initialNumberToShow = payload.numberToShow;
	let tagsArr =  [
		{
			name: 'Verksamhet',
			options: state.operations
		},
		// {
		// 	name: 'Yrkeskategori',
		// 	options: state.professions
		// },
		{
			name: 'Ämne',
			options: state.subjects
		},
		{
			name: 'Tema',
			options: state.themes
		},
	]

	if(state.articleForm == 'blog') {
		tagsArr.push(
			{
				name: 'Bloggnamn',
				options: state.blogNames
			}
		)
	}
	state.tags = tagsArr;
}

const setItemsMutation: MutationHandler<IItem[]> = (state, { payload }) => {
	state.items = payload
}

const setTotalMutation: MutationHandler<number> = (state, { payload }) => {
	state.total = payload
}

const setNumberToShowMutation: MutationHandler<number> = (state, { payload }) => {
	state.numberToShow = payload;
}

const setLoadingMutation: MutationHandler<boolean> = (state, { payload }) => {
	state.loading = payload
}

const setSortMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedSort = payload
}

const setDatesMutation: MutationHandler<any> = (state, { payload }) => {
	state.start = payload && payload.start ? payload.start : '';
	state.end = payload && payload.end ? payload.end : '';
}

const setOperationsMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedOperations = payload;
	let selectedOperationNames = payload && payload.indexOf(',') > -1 ? payload.split(',') : [payload];
	state.operations.forEach(item => {
		item.selected = selectedOperationNames.includes(item.name)
	})
}

const setSubjectsMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedSubjects = payload;
	let selectedSubjectNames = payload && payload.indexOf(',') > -1 ? payload.split(',') : [payload];
	state.subjects.forEach(item => {
		item.selected = selectedSubjectNames.includes(item.name)
	})
}

const setThemesMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedThemes = payload;
	let selectedThemeNames = payload && payload.indexOf(',') > -1 ? payload.split(',') : [payload];
	state.themes.forEach(item => {
		item.selected = selectedThemeNames.includes(item.name)
	})
}

// const setProfessionsMutation: MutationHandler<string> = (state, { payload }) => {
// 	state.selectedProfessions = payload;
// 	let selectedProfessionNames = payload && payload.indexOf(',') > -1 ? payload.split(',') : [payload];
// 	state.professions.forEach(item => {
// 		item.selected = selectedProfessionNames.includes(item.name)
// 	})
// }

const setBlogNamesMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedBlogs = payload;
	let selectedBlogNames = payload && payload.indexOf(',') > -1 ? payload.split(',') : [payload];
	state.blogNames.forEach(item => {
		item.selected = selectedBlogNames.includes(item.name)
	})
}

const setClearFiltersMutation: MutationHandler<string> = (state, {payload}) => {
	state.tags.forEach(tag => {
		tag.options.forEach(option => {
			if(option.selected) {
				option.selected = false
			}
		})
	})
}

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setItems: setItemsMutation,
	setLoading: setLoadingMutation,
	setTotal: setTotalMutation,
	setNumberToShow: setNumberToShowMutation,
	setSort: setSortMutation,
	setDates: setDatesMutation,
	setOperations: setOperationsMutation,
	setSubjects: setSubjectsMutation,
	setThemes: setThemesMutation,
	//setProfessions: setProfessionsMutation,
	setBlogNames: setBlogNamesMutation,
	setClearFilters: setClearFiltersMutation,
}

export default mutations
